import HwComboboxController from "@josefarias/hotwire_combobox"

export default class extends HwComboboxController {
    connect() {
        super.connect()
        // Watch for clicks on the clear button
        this.element.addEventListener("click", (e) => {
            if (e.target.closest(".hw-combobox__handle")) {
                this.triggerChangeAfterHandleAction()
            }
        })

        this.element.addEventListener(
            "mousedown",
            this.onMouseDown.bind(this),
            true // capture phase is important
        )
    }

    onMouseDown(e) {
        const option = e.target.closest("[role='option']")
        if (!option) return

        // Run after combobox updates the value
        setTimeout(() => this.triggerChange(), 100)
    }

    triggerChangeAfterHandleAction() {
        const previousValue = this.fieldSignature()

        setTimeout(() => {
            if (this.fieldSignature() === previousValue) return
            this.triggerChange()
        }, 700)
    }

    fieldSignature() {
        const hiddenValue = this.hiddenFieldTarget?.value || ""
        const multiValue = this.hiddenFieldTarget?.dataset?.valueForMultiselect || ""
        const displayValue = this.hiddenFieldTarget?.dataset?.displayForMultiselect || ""

        return [hiddenValue, multiValue, displayValue].join("|")
    }

    triggerChange() {
        this.hiddenFieldTarget.dispatchEvent(
            new Event("change", { bubbles: true })
        )
    }
}
